import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['modal', 'imageContainer', 'username', 'user-info']

  connect = () => {
    this.element.addEventListener('click', event => this.checkCloseable(event))
  }

  disconnect = () => {
    this.element.removeEventListener('click', event => this.checkCloseable(event))
  }

  checkCloseable = () => {
    if (this.canClose) {
      this.closeModal()
    }
  }

  openModal = ({ params: { links, username } }) => {
    if (this.modalTarget.classList.contains('hidden')) {
      this.modalTarget.classList.remove('hidden')
      this.modalTarget.classList.add('flex')
    }
    else {
      this.imageContainerTarget.innerHTML = ''
    }

    this.usernameTarget.innerHTML = username

    links.forEach((link) => {
      const myImage = new Image(168, 300)
      myImage.src = link
      this.imageContainerTarget.appendChild(myImage)
    })
  }

  closeModal = () => {
    this.modalTarget.classList.remove('flex')
    this.modalTarget.classList.add('hidden')
    this.imageContainerTarget.innerHTML = ''
  }

  get canClose() {
    return this.modalTarget.classList.contains('flex')
      && !event.target.closest('[data-user-mockups-target="modal"]')
      && !event.target.closest('[data-user-mockups-target="user-info"]')
  }
}
